import { render, staticRenderFns } from "./EventsLeaderboards.vue?vue&type=template&id=076e1108&"
import script from "./EventsLeaderboards.vue?vue&type=script&lang=js&"
export * from "./EventsLeaderboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports